import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingCart, List, X, ShieldCheck } from "@phosphor-icons/react";
import { useCart } from "@/lib/cart";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Catalog" },
  { to: "/refer", label: "Refer & Earn" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const { count } = useCart();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-logo"
          className="flex items-center gap-2 group"
        >
          <span className="bg-[#FFC107] text-black w-9 h-9 flex items-center justify-center">
            <ShieldCheck size={22} weight="fill" />
          </span>
          <span className="font-display text-2xl font-black uppercase tracking-tight">
            OBRA<span className="text-[#FFC107]">SAFE</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm uppercase tracking-[0.18em] font-semibold transition-colors ${
                  isActive ? "text-[#FFC107]" : "text-white hover:text-[#FFC107]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/cart"
            data-testid="navbar-cart-button"
            className="relative flex items-center gap-2 px-4 h-10 border border-white/20 hover:border-[#FFC107] hover:text-[#FFC107] transition-colors text-sm uppercase tracking-wider font-semibold"
          >
            <ShoppingCart size={18} weight="bold" />
            <span className="hidden sm:inline">Cart</span>
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-2 -right-2 bg-[#D32F2F] text-white text-xs font-bold w-5 h-5 flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </Link>
          <button
            className="md:hidden p-2 border border-white/20"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <List size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black">
          <div className="flex flex-col py-4">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `px-6 py-3 text-sm uppercase tracking-widest font-semibold ${
                    isActive ? "text-[#FFC107] bg-white/5" : "text-white"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
